import { NotifyErrorWrapper, NotifySuccessWrapper } from '@/helpers/core/notifications'
import { consolidateParts } from '@/services/rc/miners.service'
import { useMutation } from '@tanstack/vue-query'

export const useMinerPartSwaps = () => {
  const movePartsMutation = useMutation({
    mutationFn: consolidateParts,
    onSuccess: NotifySuccessWrapper('Parts moved successfully'),
    onError: NotifyErrorWrapper('Could not move parts'),
  })

  return { movePartsMutation }
}
